export const mpesaStkMutation = (paymentItem, phoneNumber, amount) => {
    const mutation = `
      mutation {
        sendStkPush(
            paymentItem: "${paymentItem}",
            phoneNumber: "${phoneNumber}",
            amount: ${amount}
        ) {
          errorMessage
          success
        }
      }
    `;
    return mutation;
  }
  